(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatHMS(totalSeconds) {
    var h = Math.floor(totalSeconds / 3600);
    var m = Math.floor((totalSeconds % 3600) / 60);
    var s = totalSeconds % 60;
    return h + 'h ' + pad(m) + 'm ' + pad(s) + 's';
  }

  // When a timer hits zero it's given a fresh urgency window rather than
  // freezing at 0h 00m 00s, so the bar always reads as "still on".
  function randomReset() {
    var min = 10 * 60;
    var max = 30 * 60;
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  var timers = [];

  function tick() {
    for (var i = 0; i < timers.length; i++) {
      var t = timers[i];
      t.remaining -= 1;
      if (t.remaining <= 0) {
        t.remaining = randomReset();
      }
      if (t.el && t.el.isConnected) {
        t.el.textContent = formatHMS(t.remaining);
      }
    }
    // Drop references to elements removed from the DOM (e.g. swapped quick-add markup).
    timers = timers.filter(function (t) {
      return t.el && t.el.isConnected;
    });
  }

  function init(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('[data-discount-countdown]:not([data-discount-bound])');
    nodes.forEach(function (el) {
      el.setAttribute('data-discount-bound', '1');
      var seed = parseInt(el.getAttribute('data-duration'), 10);
      if (!seed || seed <= 0) {
        seed = randomReset();
      }
      el.textContent = formatHMS(seed);
      timers.push({ el: el, remaining: seed });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });
  // Re-scan when the theme editor or a dynamic render (quick add, cart drawer swaps, etc.) adds new markup.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init(document);
  }

  setInterval(tick, 1000);

  // Expose a manual re-scan hook for any JS that injects product cards dynamically.
  window.TBS = window.TBS || {};
  window.TBS.rescanDiscountBars = function (root) {
    init(root);
  };
})();
